import { Component, HostListener, OnInit } from '@angular/core';
import { TableDropdownSectionComponent } from '../table-dropdown-section/table-dropdown-section.component';

@Component({
  selector: 'app-table-dropdown-header',
  templateUrl: './table-dropdown-header.component.html',
  styleUrls: ['./table-dropdown-header.component.css']
})
export class TableDropdownHeaderComponent {

  constructor(private dropdownSection: TableDropdownSectionComponent) { }

  get isOpen() {
    return this.dropdownSection.isOpen;
  }

  set isOpen(value) {
    this.dropdownSection.isOpen = value;
  }

  @HostListener("click") onClick() {
    this.isOpen = !this.isOpen;
  }
}
